<template>
    <div class="configurar-puntos-container">
      <div class="d-flex justify-content-between align-items-center mb-4">

        <button class="btn btn-primary" @click="nuevoPuntoAbastecimiento">
          <font-awesome-icon icon="plus" class="me-2" /> Nuevo Punto de Abastecimiento
        </button>
      </div>
  
      <!-- Componente de Gestión de Puntos de Abastecimiento -->
      <GestionPuntosAbastecimiento
        :puntos-abastecimiento="puntosAbastecimiento"
        @editar="editarPunto"
        @actualizar="cargarDatos"
      />
  
      <!-- Componente de Alta/Edición -->
      <AltaPuntoAbastecimiento
        v-if="mostrarAlta"
        :punto-abastecimiento="puntoAbastecimiento"
        :ubicaciones="ubicaciones"
        :editando="editando"
        :club_id="club_id"
        @guardar="guardarPuntoAbastecimiento"
        @reset="cancelarAlta"
      />
    </div>
  </template>
  
  <script>
  import axios from '@/axios';
  import GestionPuntosAbastecimiento from './GestionPuntosAbastecimiento.vue';
  import AltaPuntoAbastecimiento from './AltaPuntoAbastecimiento.vue';
  
  export default {
    components: {
      GestionPuntosAbastecimiento,
      AltaPuntoAbastecimiento,
    },
    data() {
      return {
        puntosAbastecimiento: [],
        ubicaciones: [], // Aquí almacenamos las ubicaciones obtenidas desde la API
        puntoAbastecimiento: {
          nombre: '',
          ubicacion_id: null,
          nivel_exactitud: 'CIUDAD',
          visible: true,
        },
        mostrarAlta: false,
        editando: false,
      };
    },
    props: {
      club_id: Number,
    },
    methods: {
      async cargarDatos() {
        try {
          // Cargar puntos de abastecimiento
          const responsePuntos = await axios.get('/api/puntos_abastecimiento', {
            params: {
              club_id: this.club_id,
            },
          });
          this.puntosAbastecimiento = responsePuntos.data;
  
          // Cargar ubicaciones desde la API
          const responseUbicaciones = await axios.get('/api/ubicaciones');
          this.ubicaciones = responseUbicaciones.data;
        } catch (error) {
          console.error('Error al cargar los datos:', error);
        }
      },
  
      // Mostrar formulario para nuevo punto de abastecimiento
      nuevoPuntoAbastecimiento() {
        this.puntoAbastecimiento = {
          nombre: '',
          ubicacion_id: null,
          nivel_exactitud: 'CIUDAD',
          visible: true,
        };
        this.editando = false;
        this.mostrarAlta = true;
      },
  
      // Editar un punto de abastecimiento
      editarPunto(punto) {
        this.puntoAbastecimiento = { ...punto };
        this.editando = true;
        this.mostrarAlta = true;
      },
  
      // Guardar un punto de abastecimiento
      async guardarPuntoAbastecimiento(puntoAbastecimiento) {
        try {
          this.puntoAbastecimiento.club_id=this.club_id;
          if (this.editando) {
            puntoAbastecimiento.nivel_exactitud=puntoAbastecimiento.nivelExactitud;

            
            // Actualizar punto existente
            await axios.put(`/api/puntos_abastecimiento/${puntoAbastecimiento.id}`, {form: puntoAbastecimiento, club_id: this.club_id});
          } else {
            // Crear nuevo punto
            await axios.post('/api/puntos_abastecimiento', {form: puntoAbastecimiento, club_id: this.club_id});
          }
          this.cargarDatos();
          this.mostrarAlta = false; // Ocultar el formulario de alta
        } catch (error) {
          console.error('Error al guardar el punto de abastecimiento:', error);
        }
      },
  
      // Cancelar la creación/edición
      cancelarAlta() {
        this.mostrarAlta = false;
      },
    },
    mounted() {
      this.cargarDatos();
    },
  };
  </script>
  